import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environments/environment.model';

export interface FootprintIssue {
  code: string;
  deliveryLineId?: number;
  productTitle?: string;
  year?: number;
  fields?: string[];
}
export interface FootprintReadiness {
  canCalculate: boolean;
  checks: { requirement: string; complete: boolean; issues: FootprintIssue[] }[];
}
export interface FootprintHistoryItem {
  id: number;
  flockId: number;
  status: number | string;
  calculatedAt?: string;
  createdAt?: string;
  resultJson: string;
}
export interface FootprintCalculation {
  flockId: number;
  status: number | string;
  errorCode?: string;
  readiness?: FootprintReadiness;
  results: FootprintHistoryItem[];
}
export function footprintStatus(status: number | string): string {
  return typeof status === 'number'
    ? (['missing', 'pending', 'inprogress', 'available', 'failed', 'timedout'][status] ?? 'failed')
    : (status ?? 'missing').toLowerCase();
}
@Injectable({ providedIn: 'root' })
export class SustainabilityBackendService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${this.env.APIM_BASE_URL}/poultry-service/public/secure/sustainability`;

  constructor(@Inject(EnvironmentInjector) private readonly env: Environment) {}

  readiness(flockId: number) {
    return this.http.get<FootprintReadiness>(`${this.baseUrl}/carbon-footprint/readiness`, {
      params: { flockId },
    });
  }
  results(flockId: number) {
    return this.http.get<FootprintCalculation>(`${this.baseUrl}/carbon-footprint`, {
      params: { flockId },
    });
  }
  calculate(flockId: number) {
    return this.http.post<FootprintCalculation>(`${this.baseUrl}/carbon-footprint`, null, {
      params: { flockId },
    });
  }
  refresh(flockId: number) {
    return this.http.post<FootprintCalculation>(`${this.baseUrl}/refresh-carbon-footprint`, null, {
      params: { flockId },
    });
  }
}
